import { Injectable } from '@angular/core';
import { ApModalService } from 'webcommon/core-ui';
import { MapInsuranceNetworkModalComponent } from './map-insurance-network-modal.component';
import { ModalSizeEnum } from '../../../models';
import { Observable } from 'rxjs';
import { FcMapNetworkResponse } from 'webcommon/shared';
import { FormGroup } from '@angular/forms';
import { NetworkRepository } from 'webcommon/webapi';

@Injectable({
  providedIn: 'root',
})
export class MapInsuranceNetworkService {

  constructor(
    private apModalService: ApModalService,
    private networkRepository: NetworkRepository,
  ) {
  }

  public openModal(
    baseId: string,
    isMapByProvider: boolean,
    providedInsurancePlanUid?: string): Promise<boolean> {

    const initialState = {
      baseId,
      isMapByProvider,
      providedInsurancePlanUid,
    };
    const componentModal: Promise<boolean> = this.apModalService.showComponentModal(MapInsuranceNetworkModalComponent, {
      panelClass: ModalSizeEnum.small,
      disableClose: true,
      initialState,
    });

    return componentModal;
  }

  public disableSaveButton(
    isOpenedAsModal: boolean,
    form: FormGroup,
    selectedToProviderPks: string[],
    selectedInsurancePlanPks: string[],
    isDeleteAllMappingFromDatabase?: boolean,
    isClearSelectedMappings?: boolean): boolean {

    switch (true) {
      case isOpenedAsModal:
        return !form.dirty;
      case isDeleteAllMappingFromDatabase || isClearSelectedMappings:
        return false;
      default:
        if (selectedToProviderPks.length > 0
          && selectedInsurancePlanPks.length > 0
          && form.dirty) {
          return false;
        } else {
          return true;
        }
    }
  }

  public getNetworkProviderItems(id: string, uId: string): Observable<string[]> {
    return this.networkRepository.getNetworksItems(id, uId);
  }

  public updateNetworkItems(id: string, uId: string, guids: string[]): Observable<FcMapNetworkResponse> {
    return this.networkRepository.updateNetworksItems(id, uId, guids);
  }

  public deleteNetworksItem(id: string): Observable<FcMapNetworkResponse> {
    return this.networkRepository.deleteNetworksItem(id);
  }
}
